import {CLOSE_LIGHTBOX, OPEN_LIGHTBOX} from "../actions/types";

const initState = {
    isLightboxOpen: false,
    src: ''
}

const LightboxReducer = (state = initState, action) => {
    const { type, payload } = action;

    switch (type) {
        case OPEN_LIGHTBOX:
            return {
                ...state,
                isLightboxOpen: true,
                src: payload.src
            }
        case CLOSE_LIGHTBOX:
            return {
                ...state,
                isLightboxOpen: false
            }
        default:
            return state;

    }
}

export default LightboxReducer


// WEBPACK FOOTER //
// ./src/reducers/lightbox-reducer.js